<script setup>

import {onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import axios from "axios";

const route = useRoute()
const dataForm = ref({
  name: '',
  phone: '',
  email: '',
  contents: '',
  client_path: '',
  client_ip: '',
  client_country: ''
})
const statusMessage = ref('');

function get_ip() {
  axios
      .get('https://api.ipify.org?format=json')
      .then(response => {
        dataForm.value.client_ip = response.data.ip
      })
      .catch(error => {
        console.log(error)
      })
}

function get_country() {
  axios
      .get('https://get.geojs.io/v1/ip/geo.json')
      .then(response => {
        dataForm.value.client_country = response.data.country
      })
      .catch(error => {
        console.log(error)
      })
}


function send_email() {
  dataForm.value.client_path = route.path
  if (dataForm.value.name === '') {
    statusMessage.value = 'The name cannot be empty!';
    return
  }
  if (dataForm.value.email === '') {
    statusMessage.value = 'The email cannot be empty!';
    return
  }
  if (dataForm.value.phone === '') {
    statusMessage.value = 'The phone cannot be empty!';
    return
  }
  axios
      .post('/api/mail', dataForm.value)
      .then(response => {
        statusMessage.value = 'Email sent successfully!';
      })
      .catch(error => {
        statusMessage.value = 'Failed to send email.';
      });
}

onMounted(() => {
  get_ip()
  get_country()
})

</script>

<template>
<div class="comments-area">
					<div class="comment-respond ">
						<div class="commment_title">
							<h3> leave a comment </h3>
						</div>
						<form @submit.prevent="send_email">
							<div class="comment_forms">
								<div class="comment_forms_inner">
									<div class="comment_field">
										<div class="input-field">
											<label>Name<em>*</em></label>
											<input v-model="dataForm.name"  name="name" type="text" placeholder="Your Name*">
										</div>
										<div class="input-field">
											<label >E-mail Address<em>*</em></label>
											<input v-model="dataForm.email"  name="email" type="text" placeholder="Email Address*">
										</div>
										<div class="input-field">
											<label>Website<em>*</em></label>
											<input v-model="dataForm.phone"  name="phone" type="text" placeholder="Your Phone*">
										</div>
									</div>
									<div class="comment_field">
										<div class="textarea-field">
											<label >Comment<em>*</em></label>
											<textarea v-model="dataForm.contents" name="comment"  placeholder="Write your comment..."></textarea>
                      <p v-if="statusMessage">{{ statusMessage }}</p>
										</div>
									</div>
								</div>
							</div>
							<button class="kurigram_btn" type="submit">Post Comment</button>
							<div class="row">
								<div class="col-lg-12 text-center">
									<p class="form-messege"></p>
								</div>
							</div>
						</form>
					</div>
				</div>
</template>

<style scoped lang="scss">

</style>